/**
 * Article rédigé le 2026-09-06 à partir de sources web ouvertes et vérifiées automatiquement
 * (6 URL testées, révisé après vérification). Daté au moment des faits : 2025-10-14.
 * À relire avant/après mise en ligne. Format : voir src/blog/README.md
 */
export default {
  "slug": "fete-de-la-science-2025-bouloie-quantique-ia",
  "title": "Fête de la science 2025 : la Bouloie ouvre ses labos, du quantique à l'IA",
  "excerpt": "Du 9 au 12 octobre, le campus de la Bouloie a accueilli le Village des sciences de Besançon. Thème national « Intelligence(s) », robots, réalité virtuelle et une conférence quantique à guichets fermés.",
  "seoTitle": "Fête de la science 2025 : la Bouloie et l'IA",
  "seoDescription": "Du 9 au 12 octobre 2025, le Village des sciences de la Bouloie a proposé une trentaine d'animations sur le thème « Intelligence(s) », du quantique à l'IA.",
  "category": "evenements",
  "tags": [
    "Fête de la science",
    "Université Marie et Louis Pasteur",
    "FEMTO-ST",
    "Bouloie",
    "Quantique"
  ],
  "author": "jimmy",
  "publishedAt": "2025-10-14",
  "updatedAt": "2025-10-14",
  "featured": false,
  "cover": {
    "image": "/img/blog/besancon-le-batiment-des-propedeutiques-de-l-ufr-des-science.jpg",
    "credit": "Photo : Besançon, le bâtiment des Propédeutiques de l'UFR des Sciences et Techniques — Wikipedro, CC BY-SA 4.0, via Wikimedia Commons",
    "alt": "Le bâtiment des Propédeutiques de l'UFR Sciences et Techniques, sur le campus de la Bouloie à Besançon : une façade en pierre dorée ornée de symboles du tableau périodique des éléments, sous un ciel bleu"
  },
  "content": [
    {
      "type": "lead",
      "text": "Du 9 au 12 octobre 2025, [le campus de la Bouloie](/blog/se-former-ia-besancon-guide-voies-acces) a accueilli le Village des sciences de Besançon : deux journées réservées aux scolaires, deux après-midi ouverts à tous, et « plus d'une trentaine d'animations » portées par les laboratoires, musées et associations du territoire [^1][^2]. Une édition placée sous le thème national « Intelligence(s) », prolongée le vendredi 10 octobre par une conférence de physique quantique dont les inscriptions en présentiel affichaient complet [^4]."
    },
    {
      "type": "keyfacts",
      "facts": [
        {
          "label": "Quoi",
          "value": "Village des sciences de la Fête de la science 2025, sous le thème national « Intelligence(s) »"
        },
        {
          "label": "Quand",
          "value": "9 et 10 octobre pour les scolaires, 11 et 12 octobre de 14 h à 18 h pour le grand public"
        },
        {
          "label": "Où",
          "value": "Campus de la Bouloie, accueil au bâtiment Propédeutique, 16 route de Gray"
        },
        {
          "label": "Qui",
          "value": "Université Marie et Louis Pasteur, coordination régionale assurée par le Pavillon des sciences"
        },
        {
          "label": "Pour qui",
          "value": "Gratuit et ouvert à tous, la plupart des ateliers accessibles dès 6 ans"
        }
      ]
    },
    {
      "type": "h2",
      "text": "« Intelligence(s) » : un thème national, une affiche dont l'image doit à l'IA"
    },
    {
      "type": "p",
      "text": "L'édition 2025 de la Fête de la science s'est tenue du 3 au 13 octobre autour du thème « Intelligence(s) », une invitation à explorer aussi bien l'intelligence humaine, animale et végétale que l'intelligence artificielle. En Bourgogne-Franche-Comté, la manifestation annonçait plus de cent événements et la participation de plus de cent cinquante structures — laboratoires, associations, musées, universités — répartis sur sept villages des sciences, dont celui de Besançon [^6]."
    },
    {
      "type": "p",
      "text": "Le détail est discret, mais il en dit long sur l'année écoulée : l'affiche officielle de l'édition, un visage composé de feuillages sur fond vert, porte en bord de page le crédit « Conception graphique : MESR / Delcom 1 / Image créée à l'aide d'une intelligence artificielle » [^2]. Le thème s'appliquait donc à lui-même, jusque dans son support de communication. Autre signe des temps, l'ambassadrice régionale désignée pour cette édition est **Karine Deschinkel**, professeure en informatique à l'Université Marie et Louis Pasteur et directrice du département DISC de [l'institut FEMTO-ST](/blog/femto-st-besancon-capitale-microtechniques) [^3] — soit, pour une édition consacrée aux intelligences, une figure venue des sciences du numérique, que K6FM présente pour sa part comme spécialiste de l'optimisation appliquée à l'environnement et à l'agriculture [^6]."
    },
    {
      "type": "h2",
      "text": "Robots, casques et escape game : le numérique en accès libre"
    },
    {
      "type": "p",
      "text": "À Besançon, l'organisation revenait à l'[Université Marie et Louis Pasteur](https://actu.umlp.fr/agenda/fete-de-la-science-2025-besancon-0), avec le soutien de la Région Bourgogne-Franche-Comté, de Grand Besançon Métropole et de la Ville de Besançon, la coordination régionale étant assurée par le Pavillon des sciences [^1]. Le Village s'est déployé sur plusieurs points du campus : le bâtiment Propédeutique, le BIOME et sa serre, le learning centre Claude Oytana et l'Observatoire de Besançon [^2]."
    },
    {
      "type": "p",
      "text": "Dans le programme grand public publié par l'université, plusieurs propositions relevaient directement de la recherche numérique et physique du bassin :"
    },
    {
      "type": "ul",
      "items": [
        "**À la rencontre des robots**, à la Fabrika du BIOME, animé par l'institut FEMTO-ST, avec une séance toutes les heures dès 6 ans [^2] ;",
        "**La réalité virtuelle au service de l'apprentissage**, en salle de réalité virtuelle du learning centre Claude Oytana, une séance toutes les demi-heures [^2] ;",
        "**Rouler des mécaniques**, au Fablab du learning centre [^2] ;",
        "**Escape game scientifique**, proposé par l'UFR Sciences et techniques et FEMTO-ST, réservé aux visiteurs de 15 ans et plus [^2] ;",
        "**Questions pour un photon**, également signé FEMTO-ST, dès 11 ans [^2] ;",
        "**Logique ?**, porté par l'IREM de Franche-Comté et le Laboratoire de mathématiques de Besançon, et **L'archéologie en 3D : entre virtuel et réalité**, avec la Maison des sciences de l'homme et de l'environnement [^2]."
      ]
    },
    {
      "type": "p",
      "text": "Un constat s'impose à la lecture de ce programme : malgré le thème national, aucun atelier explicitement estampillé « intelligence artificielle » n'y figurait côté grand public [^2]. Le numérique s'y est glissé autrement — par la robotique, par les casques de réalité virtuelle, par le raisonnement logique et le jeu d'énigmes : une médiation par la manipulation plutôt que par le discours. Le dépliant renvoyant au programme détaillé publié sur fetedelascience.fr, cette lecture vaut pour les animations qu'il annonce."
    },
    {
      "type": "h2",
      "text": "Le quantique, point d'orgue à guichets fermés"
    },
    {
      "type": "p",
      "text": "Le rendez-vous soumis à inscription s'est tenu le vendredi 10 octobre à 18 h, dans l'amphi A de l'UFR Sciences et techniques : une conférence de **Philippe Grangier** (Université Paris-Saclay, CNRS, Institut d'optique Graduate School), participant de la célèbre expérience d'Aspect sur l'intrication quantique [^5]. Intitulée « Des fondements de la mécanique quantique aux technologies quantiques », elle proposait un parcours allant des débats fondateurs du début du XXᵉ siècle jusqu'aux applications actuelles : cryptographie, télécommunications, ordinateurs quantiques [^4][^5]."
    },
    {
      "type": "p",
      "text": "Au programme annoncé : une introduction par le professeur **John Dudley** (Université Marie et Louis Pasteur) et un temps d'échange avec le public en clôture, dans le cadre de l'Année internationale du quantique de l'UNESCO [^5]. L'entrée était gratuite mais la jauge limitée à 300 personnes, et les inscriptions en présentiel ont affiché complet ; FEMTO-ST a ouvert une diffusion en ligne, annoncée sur la [page de l'événement](https://www.femto-st.fr/fr/L-institut/evenements/conference-des-fondements-de-la-mecanique-quantique-aux-technologies), pour suivre la séance à distance [^4]."
    },
    {
      "type": "p",
      "text": "Le lien avec Besançon n'est pas anecdotique. Les travaux de Philippe Grangier ont débouché sur une nouvelle technique de cryptage quantique « actuellement mise en œuvre par la société Exail à Besançon » [^5]. Autrement dit, la conférence ne parlait pas d'un horizon lointain : elle décrivait une chaîne qui va du laboratoire à une entreprise installée sur le territoire."
    },
    {
      "type": "callout",
      "tone": "info",
      "title": "Pourquoi ça compte pour Besançon",
      "text": "Une fête de la science n'est pas qu'une sortie familiale : c'est le moment où un écosystème de recherche devient visible pour ceux qui le financent et qui, demain, y travailleront peut-être. En deux après-midi ouverts à tous — après deux journées réservées aux scolaires — et une soirée de conférence, la Bouloie a exposé côte à côte ses robots, ses casques de réalité virtuelle et sa physique quantique, trois domaines où Besançon dispose d'équipes et, dans le cas du quantique, d'un débouché industriel local identifié [^2][^5]."
    },
    {
      "type": "h2",
      "text": "Ce que cette édition laisse voir"
    },
    {
      "type": "p",
      "text": "L'université n'a pas publié de bilan de fréquentation à ce stade, et il serait hasardeux d'en avancer un. Ce que l'on peut constater, en revanche, c'est la cohérence de l'assemblage : un thème national sur les intelligences, une ambassadrice régionale issue de l'informatique, une conférence de quantique fondamental plafonnée à 300 participants et complète en présentiel, et des ateliers de campus conçus pour être manipulés dès 6 ans [^2][^3][^4][^6]. La médiation scientifique fonctionne ici comme une vitrine — au sens le plus utile du terme : elle montre ce qui existe déjà, à quelques centaines de mètres de là."
    }
  ],
  "references": [
    {
      "id": 1,
      "title": "Fête de la science 2025 — Besançon",
      "publisher": "Université Marie et Louis Pasteur",
      "url": "https://actu.umlp.fr/agenda/fete-de-la-science-2025-besancon-0",
      "type": "official",
      "date": "2025-06-05"
    },
    {
      "id": 2,
      "title": "Programme de la Fête de la science 2025 — Besançon, campus de la Bouloie (PDF)",
      "publisher": "Université Marie et Louis Pasteur",
      "url": "https://actu.umlp.fr/sites/default/files/fete_de_la_science_2025_besancon_w.pdf",
      "type": "official",
      "date": "2025-09-25"
    },
    {
      "id": 3,
      "title": "Fête de la Science 2025 : le rendez-vous incontournable gratuit qui célèbre les sciences, les techniques et les innovations",
      "publisher": "Institut FEMTO-ST",
      "url": "https://www.femto-st.fr/fr/L-institut/evenements/fete-de-la-science-2025-le-rendez-vous-incontournable-gratuit-qui-celebre-les",
      "type": "official",
      "date": "2025-09-22"
    },
    {
      "id": 4,
      "title": "Conférence : Des fondements de la mécanique quantique aux technologies quantiques",
      "publisher": "Institut FEMTO-ST",
      "url": "https://www.femto-st.fr/fr/L-institut/evenements/conference-des-fondements-de-la-mecanique-quantique-aux-technologies",
      "type": "official",
      "date": "2025-09-15"
    },
    {
      "id": 5,
      "title": "Conférence : Des fondements de la mécanique quantique aux technologies quantiques",
      "publisher": "Université Marie et Louis Pasteur",
      "url": "https://actu.umlp.fr/agenda/conference-des-fondements-de-la-mecanique-quantique-aux-technologies-quantiques",
      "type": "official",
      "date": "2025-10-06"
    },
    {
      "id": 6,
      "title": "Fête de la Science 2025 : la Bourgogne-Franche-Comté célèbre l'intelligence sous toutes ses formes",
      "publisher": "K6FM",
      "url": "https://www.k6fm.com/fete-de-la-science-2025-la-bourgogne-franche-comte-celebre-l-intelligence-sous-toutes-ses-formes",
      "type": "press",
      "date": "2025-09-16"
    }
  ]
};
